import { Api } from '../../api/api.module'
import { $ELEMENT_SERVICE_NAME, $SCOPE_SERVICE_NAME } from '../../../services/system'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { SchemaDirectiveController } from './schema.directive.controller'

//#region Asset Imports

import './schema.scss'
import * as TEMPLATE from './schema.tpl.html'

//#endregion

export class SchemaDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        source: '=',
        id: '=?',
        schemaOwner: '='
    }
    template = TEMPLATE

    controller = [
        $SCOPE_SERVICE_NAME,
        $ELEMENT_SERVICE_NAME,
        'api',
        USER_SESSION_SERVICE_NAME,
        (
            $scope,
            $element: JQuery,
            api: Api,
            userSession: UserSessionService
        ) => new SchemaDirectiveController(
            $scope,
            $element,
            api,
            userSession
        )]

    replace = true
}